<template>
  <div class="input-wrap">
    <textarea
      v-if="type === 'textarea'"
      type="text"
      :value="value"
      @input="input"
      :maxlength="maxlength ? maxlength : false"
      :minlength="minlength ? minlength : false"
      :placeholder="placeholder"
      :disabled="disabled"
    />
    <input
      v-else
      type="text"
      :value="value"
      @input="input"
      :maxlength="maxlength ? maxlength : false"
      :minlength="minlength ? minlength : false"
      :placeholder="placeholder"
      :disabled="disabled"
    />
  </div>
</template>

<script>
export default {
  props: [
    "value",
    "type",
    "disabled",
    "digitsAndFloatOnly",
    "minlength",
    "maxlength",
    "placeholder",
  ],
  data() {
    return {};
  },
  methods: {
    input(e) {
      if (this.digitsAndFloatOnly) {
        e.target.value = e.target.value
          .replace(/[^0-9.]/g, "")
          .replace(/(\..*?)\..*/g, "$1");
      }

      this.$emit("input", e.target.value);
    },
  },
  mounted() {},
};
</script>

<style lang='scss' scoped>
.input-wrap {
  border-radius: 4px;
  border: solid 1px grey;
  height: fit-content;

  input,
  textarea {
    background: inherit;
    border: 0;
    resize: none;
    color: inherit;
    outline: none;
    padding: 3px;
    height: 100%;
    width: 100%;
  }

  textarea {
    width: calc(100% - 5px);
  }
  ::-webkit-scrollbar {
    display: none;
  }
}
</style>
